// Generated by tools/build-assets.mjs from assets/fighters (npm run assets): don't edit.
/** Every fighter (assets/fighters/<id>/rig.json): league bots pick theirs from these. */
export const ROSTER: readonly string[] = ['axo', 'bolt', 'buzz', 'chomp', 'ember', 'goo', 'leo', 'moss', 'ronin', 'spike', 'waddle', 'yeti'];
